export default __webpack_public_path__ + "static/media/836.54b46814.png";